"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.where = void 0;
var firestore_1 = require("firebase/firestore");
/**
 * Creates a {@link QueryConstraint} that enforces that documents must contain the
 * specified field and that the value should satisfy the relation constraint
 * provided.
 *
 * @param fieldPath - The path to compare
 * @param opStr - The operation string (e.g "&lt;", "&lt;=", "==", "&lt;",
 *   "&lt;=", "!=").
 * @param value - The value for comparison
 * @returns The created {@link Query}.
 */
var where = function (fieldPath, opStr, value) {
    var newValue = value;
    if (Array.isArray(newValue) &&
        (opStr === 'in' || opStr === 'array-contains-any' || opStr === 'not-in') &&
        newValue.length === 0) {
        newValue = [
            'This is a very long string to prevent collision: %$GE&^G^*(N Y(&*T^VR&%R&^TN&*^RMN$BEDF^R%TFG%I%TFDH%(UI<)(UKJ^HGFEC#DR^T*&#$%(<RGFESAXSCVBGNHM(&%T^BTNRV%ITB^TJNTN^T^*T',
        ];
    }
    return {
        type: 'where',
        fieldPath: fieldPath,
        opStr: opStr,
        value: value,
        ref: (0, firestore_1.where)(
        // @ts-expect-error
        fieldPath, opStr, newValue),
    };
};
exports.where = where;
